export default "__VITE_ASSET__BIOC6n13__ 150w, __VITE_ASSET__DaJGVy1E__ 300w, __VITE_ASSET__DzaJ1hfK__ 450w";